import { PropsWithChildren } from 'react';

import { cn } from '@/lib/utils';

interface SignUpContentTitleProps extends PropsWithChildren {
  className?: string;
}

const SignUpContentTitle = ({
  children,
  className,
}: SignUpContentTitleProps) => {
  return (
    <h1 className={cn('font-heading text-3xl font-semibold', className)}>
      {children}
    </h1>
  );
};

export default SignUpContentTitle;
